import { Alert } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { errorKey } from '../routing.js';

export function ErrorAlert({ code }: { code: string | null }) {
  const { t } = useTranslation();
  if (!code) return null;
  return (
    <Alert color="red" variant="light" icon={<IconAlertCircle size={18} />} mb="lg" role="alert">
      {t(errorKey(code))}
    </Alert>
  );
}
